var $596d9ed84c15df98$exports = {};
$596d9ed84c15df98$exports = {
    "info": `Informace`,
    "negative": `Chyba`,
    "notice": `Varov\xe1n\xed`,
    "positive": `\xdasp\u{11B}ch`
};


export {$596d9ed84c15df98$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
